export default __webpack_public_path__ + "daf561952d9e9ddbec094ba91053061f.png";